export const SALES_ANALYTICS_EVENTS = {
  SALES_STATS_FETCHED: "sales-stats-fetched",
  SALES_SECTOR_FETCHED: "sales-sector-fetched",
  SALES_PRODUCTIVIY_FETCHED: "sales-productivity-fetched",
  SALES_MY_TEAM_FETCHED: "sales-my-team-fetched",
};
